define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var template = require("web-agent-templates/chatLineStateBubbleView.tmpl");

    var ChatLineStateBubbleView = {};

    LE.module(CONST.MODULES.AGENT, function (LEWebAgent, LE, Backbone, Marionette, $, _) {
        ChatLineStateBubbleView = Marionette.ItemView.extend({
            template: template,
            initialize: function (options) {
                this.text = options.text;
            },
            customTemplateHelpers: function () {
                return {
                    text: this.text
                };
            }
        });
    });

    return ChatLineStateBubbleView;

});
